import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Form,
  Input,
  TabPane,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  CardHeader,
  CardTitle,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DateTime from 'react-datetime';
import TagsInput from 'react-tagsinput'

import ReactSelect from 'components/Form/Select/Select';
import Loading from 'lib/loading';
import rotas from 'services/rotas';
import rest from 'lib/rest';
import settings from 'settings';
import Swal from 'sweetalert2';
import { toDecimal, calculaMarkup } from 'lib/funcoesNumericas';
import cellEditFactory from 'react-bootstrap-table2-editor';
import DataTable from './DataTable/DataTable';
import { PaginationItem } from 'reactstrap';
import { PaginationLink } from 'reactstrap';
import { Pagination } from 'reactstrap';
import { Table } from 'reactstrap';
import moment from 'moment';
import { Collapse } from 'reactstrap';
import useCentralLojas from 'lib/useCentralLojas';

const Precificacoes = () => {

  const listaAlteracoes = [{ id: 1, title: 'Incremental' }, { id: 2, title: 'Decremental' }, { id: 3, title: 'Valor Fixo' }];
  // const listaPrecos = [{ id: 1, title: 'Preço de Venda' }, { id: 2, title: 'Preço de Promoção' }, { id: 3, title: 'Preço de Crediário' }];
  const listaTipoValor = [{ id: 1, title: '(R$) Valor' }, { id: 2, title: '(%) Porcentagem' }];
  const listaPrecoBase = [{ id: 1, title: 'Sobre o Preço de Compra' }, { id: 2, title: 'Sobre o Preço de Venda' }, { id: 3, title: 'Sobre o Preço de Promoção' }, { id: 4, title: 'Sobre o Preço de Crediário' }];
  const listaFiltros = [{
    id: 1,
    title: 'Nota Fiscal'
  }, {
    id: 2,
    title: 'Produto'
  }, {
    id: 3,
    title: 'Categoria'
  }, {
    id: 4,
    title: 'Subcategoria'
  }, {
    id: 5,
    title: 'Grupo de Compras'
  }, {
    id: 6,
    title: 'Fabricante'
  }, {
    id: 7,
    title: 'Faixa de Markup'
  }]

  const initialOpcoes = {
    prod_saldo: 'N',
    preco_zero: 'N',
    preco_nao_zero: 'N'
  }


  const inititalParams = {
    tipoAlteracao: '',
    tipoPreco: '',
    tipoValor: '',
    precoBase: '',
    valorReajustar: 0
  }


  /* const colunas = [
     {
       dataField: '',
       text: '',
       headerStyle: { cursor: 'default' },
       width: '50px',
       checkbox: true
     },
     {
       dataField: 'produto_id',
       text: 'Código',
       headerStyle: { cursor: 'default' },
       width: '80px'
     }, {
       dataField: 'cod_barras',
       text: 'Cód Barras',
       align: 'left',
       headerStyle: { cursor: 'default' },
       width: '110px'
     },
     // {
     //   dataField: 'produto',
     //   text: 'Produto',
     //   align: 'left',
     //   headerStyle: { cursor: 'default' },
     //   style: (cell, row, rowIndex, colIndex) => {
     //     return {
     //       // fontSize: '0.5rem',
     //       whiteSpace: 'normal'
     //     };
     //   }
     // }, {
     //   dataField: 'apresentacao',
     //   text: 'Apresentação',
     //   align: 'left',
     //   headerStyle: { cursor: 'default' },
     //   style: (cell, row, rowIndex, colIndex) => {
     //     return {
     //       // fontSize: '0.5rem',
     //       whiteSpace: 'normal'
     //     };
     //   }
     // },
     {
       dataField: 'item_notas_quant',
       text: 'Qtde. Comprada',
       align: 'center',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'imposto_pago',
       text: 'Imposto Pago',
       align: 'center',
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'prod_saldo',
       text: 'Saldo Atual',
       align: 'center',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'valor_ult_compra',
       text: 'Pr. Compra',
       align: 'center',
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'valor_penultima_compra',
       text: 'Penultima Compra',
       align: 'center',
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'variacao_preco',
       text: 'Variação de Preço',
       align: 'center',
       sufix: '%',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'curva_classe',
       text: 'ABC',
       align: 'center',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '50px'
     }, {
       dataField: 'markup',
       text: 'Markup',
       align: 'center',
       width: '80px',
       sufix: '%',
       headerStyle: { cursor: 'default' },
       formatter: (cellContent, row) => {
         const precos = {
           preco_compra: row.valor_ult_compra,
           preco_venda: row.prod_prvenda,
           preco_promocao: row.prod_prpromocao,
           preco_crediario: row.prod_prcrediario
         }
         let markup = calculaMarkup(precos);
         return (markup + '%')
       }
     }, {
       dataField: 'margem_lucro',
       text: 'Margem Lucro',
       align: 'center',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       sufix: '%',
       width: '80px'
     }, {
       dataField: 'padrao_comissao',
       text: 'Comissão',
       align: 'left',
       sufix: '%',
       headerStyle: { cursor: 'default' },
       width: '80px'
     }, {
       dataField: 'desconto_maximo',
       text: 'Desc. Máx',
       align: 'center',
       sufix: '%',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'preco_revista',
       text: 'Preço Revista',
       align: 'center',
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px'
     }, {
       dataField: 'prod_prvenda',
       text: 'Pr. Venda',
       align: 'center',
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       width: '80px',
       editable: true,
       currency: true,
       formatter: (cellContent, row) => {
         return (toDecimal(row.prod_prvenda))
       }
     }, {
       dataField: 'prod_prpromocao',
       text: 'Pr. Promoção',
       align: 'center',
       width: '80px',
       editable: true,
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       formatter: (cellContent, row) => {
         return (toDecimal(row.prod_prpromocao))
       }
     }, {
       dataField: 'prod_prcrediario',
       text: 'Pr. Crediário',
       align: 'center',
       width: '80px',
       editable: true,
       currency: true,
       headerStyle: { cursor: 'default', whiteSpace: 'break-spaces' },
       formatter: (cellContent, row) => {
         return (toDecimal(row.prod_prcrediario))
       }
     },
     // {
     //   dataField: 'exlcuir',
     //   text: 'Excluir',
     //   width:'80px',
     //   editable: false,
     //   formatter: (cellContent, row) => {
     //     return (
     //       <Button
     //         className="btn-icon btn-neutral"
     //         color="danger"
     //         id=""
     //         size="md"
     //         type="button"
     //         onClick={() => { excluirItem(row) }}
     //       >
     //         <i className="fas fa-times" />
     //       </Button>
     //     )
     //   }
     // }
   ];*/

  const initialColunas = [{
    dataField: '',
    text: '',
    headerStyle: { cursor: 'default' },
    width: '50px',
    checkbox: true
  }]

  const initialFiltroMarkup = { menorMarkup: '', maiorMarkup: '' };

  const { SearchBar } = Search;
  const [colunas, setColunas] = useState(initialColunas);
  const [dadosColunas, setDaddosColunas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingComponent, setLoadingComponent] = useState(false);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [data, setData] = useState([]);
  const [dataSite, setDataSite] = useState([]);
  const [tags, setTags] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [grupoCompras, setGrupoCompras] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [filialID, setFilialId] = useState(0);
  const [produtoPesquisa, setProdutoPesquisa] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [filtro, setFiltro] = useState([]);
  const [parametrosPrecificador, setParametrosPrecificador] = useState(inititalParams);
  const [tipoFiltroPrecificacao, setTipoFiltroPrecificacao] = useState('');
  const [listaPerfilPreco, setListaPerfilPreco] = useState([{ id: '', title: '' }]);
  const [historicoPrecificacao, setHistoricoPrecificacao] = useState([]);
  const [filtroHistorico, setFiltroHistorico] = useState({ dataInicial: '', dataFinal: '' })
  const [readOnlyTable, setReadOnlyTable] = useState(false)
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  const [pagina, setPagina] = useState(0);
  const [quantPagina, setQuantPagina] = useState(10);
  const [controlePaginacao, setControlePaginacao] = useState({ paginasExibir: [], totalPaginas: 0 })
  const [filtroMarkup, setFiltroMarkup] = useState(initialFiltroMarkup)
  const [opcoes, setOpcoes] = useState(initialOpcoes);
  const [disableValor, setDisableValor] = useState(false);
  const [defaultTipoValor, setDefaultTipoValor] = useState({})
  const [defaultValorOrigem, setDefaultValorOrigem] = useState({})
  const [listaNotasDuplicadas, setListaNotasDuplicadas] = useState([]);
  const [onlyChecked, setOnlyChecked] = useState(false);
  const [modalColunas, setModalColunas] = useState(false);
  const [listaPrecos, setListaPrecos] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }

    // if (tab == '2') {
    //   setOnlyChecked(true);
    // } else {
    //   setOnlyChecked(false);
    // }
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listarLojas();
      listarCategorias();
      listarSubcategorias();
      listarGrupoCompras();
      listarFabricantes();
      listarColunas();
      r();
    }
  }, [])

  useEffect(() => {
    if (parametrosPrecificador.tipoAlteracao == 'Valor Fixo') {
      setDefaultTipoValor({ id: 0, title: '(R$) Valor' });
      setDefaultValorOrigem(undefined);
      setDisableValor(true);
    } else {
      setDisableValor(false);
      setDefaultTipoValor(undefined);
      setDefaultValorOrigem(undefined);
    }
  }, [parametrosPrecificador.tipoAlteracao])

  useEffect(() => {
    paginar();

  }, [pagina])

  const r = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (modalColunas == false) {
      listarColunas();
    }
  }, [modalColunas])

   useEffect(() => {
    trataCamposPreco();
    resetParams();
  }, [filialID])

  const listarColunas = () => {
    const url = rotas.precificacaoColunas;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setDaddosColunas(ret.lista);       
      }
    })
  }

  const trataCamposPreco = () => {
    let col = [];
    let lstPrecos = [];    
    const campos = ['prod_prvenda', 'prod_prpromocao', 'prod_prcrediario'];
    dadosColunas.map(coluna=>{
      if(campos.includes(coluna.datafield)){              
        coluna.editable = ( lojas.findIndex((loja) => {              
            return((((loja.id == filialID) && (loja.campos.includes(coluna.datafield)))||((loja.is_central == 'S')&&(loja.id == filialID))) ? true : false);
          })) == -1 ? false : true; 
        


          if((coluna.datafield == 'prod_prvenda')&&(coluna.editable == true)){
            lstPrecos.push({ id: 1, title: 'Preço de Venda' });
          }

          if((coluna.datafield == 'prod_prpromocao')&&(coluna.editable == true)){
            lstPrecos.push({ id: 2, title: 'Preço de Promoção' });
          }

          if((coluna.datafield == 'prod_prcrediario')&&(coluna.editable == true)){
            lstPrecos.push({ id: 3, title: 'Preço de Crediário' });
          }                
        }               
      col.push(coluna);             
    })    
    setColunas(col);
    setListaPrecos(lstPrecos);      
  }

  const recalculaMargemMkp = () => {
    const ds = dataSite.map(lista => {
      if (!lista.checked) return lista;
      return {
        ...lista,
        markup: calculaMarkup({
          valor_ult_compra: lista.valor_ult_compra,
          prod_prvenda: lista.prod_prvenda,
          prod_prpromocao: lista.prod_prpromocao,
          prod_prcrediario: lista.prod_prcrediario
        }),
        margem_lucro: calculaMargemLucro({
          valor_ult_compra: lista.valor_ult_compra,
          prod_prvenda: lista.prod_prvenda,
          prod_prpromocao: lista.prod_prpromocao,
          prod_prcrediario: lista.prod_prcrediario
        })
      };
    });
    setDataSite(ds);

    const dt = data.map(lista => ({
      ...lista,
      markup: calculaMarkup({
        valor_ult_compra: lista.valor_ult_compra,
        prod_prvenda: lista.prod_prvenda,
        prod_prpromocao: lista.prod_prpromocao,
        prod_prcrediario: lista.prod_prcrediario
      }),
      margem_lucro: calculaMargemLucro({
        valor_ult_compra: lista.valor_ult_compra,
        prod_prvenda: lista.prod_prvenda,
        prod_prpromocao: lista.prod_prpromocao,
        prod_prcrediario: lista.prod_prcrediario
      })
    }));
    setData(dt);
  }

  const onFieldChange = (produto_id, fieldName, value) => {
    const update = (item) => {
      if (item.produto_id !== produto_id) return item;
      const upd = { ...item, [fieldName]: value };
      upd.markup = calculaMarkup({
        valor_ult_compra: upd.valor_ult_compra,
        prod_prvenda:     upd.prod_prvenda,
        prod_prpromocao:  upd.prod_prpromocao,
        prod_prcrediario: upd.prod_prcrediario
      });
      upd.margem_lucro = calculaMargemLucro({
        valor_ult_compra: upd.valor_ult_compra,
        prod_prvenda:     upd.prod_prvenda,
        prod_prpromocao:  upd.prod_prpromocao,
        prod_prcrediario: upd.prod_prcrediario
      });
      return upd;
    };
    setDataSite(prev => prev.map(update));
    setData(prev => prev.map(update));
  };

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }

  const handleAddition = (evt) => {
    let flt = [];

    filtro.map(item => {
      evt.map(tag => {
        if (item.chave === tag) {
          flt.push(item);
        }
      })
    })

    setTags(evt);
    setFiltro(flt);
    setRefresh(refresh + 1);
  }

  const paginar = () => {
    let dt = [];
    let inicio = 0;
    let fim = 0;
    let paginasExibir = [];

    const totalPaginas = Math.ceil(dataSite.length / quantPagina);

    if (pagina > 0) {
      inicio = ((pagina - 1) * quantPagina);
      fim = inicio + quantPagina;
    }

    if (pagina > 3) {
      if (pagina <= totalPaginas) {
        for (let x = -1; x <= 1; x++) {
          if ((pagina + x) <= totalPaginas) {
            paginasExibir.push((pagina + x));
          }
        }
      }
    } else {
      if (totalPaginas > 3) {
        paginasExibir = [1, 2, 3]
      } else {
        for (let x = 1; x <= totalPaginas; x++) {
          paginasExibir.push(x)
        }
      }
    }

    if (dataSite.length > 0) {
      for (let x = inicio; x < fim; x++) {
        if (x < dataSite.length) {
          dt.push(dataSite[x]);
        }
      }
      setData(dt);
      setControlePaginacao({ paginasExibir: paginasExibir, totalPaginas: totalPaginas })
    }
  }

  const listarLojas = () => {
    const url = settings.url + rotas.lojasPrecificador;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({  id:         lst.filial_id, 
                        title:      lst.fantasia, 
                        filial_id:  lst.filial_id, 
                        campos:     lst.campos.map(col => col.toLowerCase && col.toLowerCase()), 
                        is_central: lst.is_central });
        });
        setLojas(lista);
      }
    })
  }

  const listarCategorias = () => {
    const url = settings.url + rotas.categoriaProduto;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setCategorias(lista);
      }
    })
  }

  const listarSubcategorias = () => {
    const url = settings.url + rotas.subcategoria;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({ id: lst.subcategoria_id, title: lst.subcategoria });
        });
        setSubcategorias(lista);
      }
    })
  }

  const menorPreco = (precos) => {
    let retorno = 0;
    let preco_venda = 0;
    let preco_promocao = 0;
    let preco_crediario = 0;

    preco_venda = Number(precos.prod_prvenda);
    preco_promocao = Number(precos.prod_prpromocao);
    preco_crediario = Number(precos.prod_prcrediario);

    //COLOCA O PRECO A COMPARAR IGUAL A UM DOS PRECOS PRA NAO FICAR ZERADO
    if ((retorno == 0) && (preco_venda > 0)) {
      retorno = preco_venda;
    } else {
      if ((retorno == 0) && (preco_promocao > 0)) {
        retorno = preco_promocao;
      }
      else
        if ((retorno == 0) && (preco_crediario > 0)) {
          retorno = preco_crediario;
        };
    }

    //COMPARA OS PRECOS PARA O VALOR A COMPARAR FICAR COM O MENOR DELES
    if ((retorno > preco_venda) && (preco_venda > 0)) {
      retorno = preco_venda;
    };

    if ((retorno > preco_promocao) && (preco_promocao > 0)) {
      retorno = preco_promocao;
    };

    if ((retorno > preco_crediario) && (preco_crediario > 0)) {
      retorno = preco_crediario;
    };
    return (retorno);
  }

  const calculaMargemLucro = (precos) => {
    let diferenca = 0;
    let valorComparar = 0;
    let total = 0;

    let preco_compra = precos.valor_ult_compra;

    if (preco_compra > 0) {
      valorComparar = menorPreco(precos);

      //CALCULA A MARGEM DE LUCRO COM O MENOR DOS PRECOS
      if (valorComparar > 0) {
        diferenca = valorComparar - preco_compra;
        total = ((diferenca / valorComparar) * 100);
        total = total.toFixed(2);
      };
    };

    return (total);
  }

  const calculaMarkup = (precos) => {
    let diferenca = 0;
    let valorComparar = 0;
    let total = 0;

    if (precos.valor_ult_compra > 0) {
      //COLOCA O PRECO A COMPARAR IGUAL A UM DOS PRECOS PRA NAO FICAR ZERADO
      // if((valorComparar===0)&&(precos.preco_venda>0)){
      //   valorComparar=precos.preco_venda;
      // }
      // else
      // if((valorComparar===0)&&(precos.preco_promocao>0)){
      //   valorComparar=precos.preco_promocao;
      // }
      // else
      // if((valorComparar===0)&&(precos.preco_crediario>0)){
      //   valorComparar=precos.preco_crediario;
      // }

      // //COMPARA OS PRECOS PARA O VALOR A COMPARAR FICAR COM O MENOR DELES
      // if((valorComparar > precos.preco_venda)&&(precos.preco_venda > 0)){
      //   valorComparar=precos.preco_venda;
      // }

      // if((valorComparar > precos.preco_promocao)&&(precos.preco_promocao > 0)){
      //   valorComparar=precos.preco_promocao;
      // }

      // if((valorComparar > precos.preco_crediario)&&(precos.preco_crediario>0)){
      //   valorComparar=precos.preco_crediario;
      // }

      //CALCULA O MARKUP COM O MENOR DOS PRECOS
      valorComparar = menorPreco(precos);
      diferenca = valorComparar - precos.valor_ult_compra;
      total = ((diferenca / precos.valor_ult_compra) * 100);
      total = toDecimal(total);
      // console.log(`valor comparar - ${valorComparar}`);
      // console.log(`valor ult compra - ${precos.valor_ult_compra}`);
      // console.log(`valor diferenca - ${diferenca}`);
    }
    return (total);
  }

  const listarGrupoCompras = () => {
    const url = settings.url + rotas.grupoCompras;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let lista = [];

        ret.grupo.map(lst => {
          lista.push({ id: lst.grupo_id, title: lst.grupo });
        });
        setGrupoCompras(lista);
      }
    })
  }

  const listarFabricantes = () => {
    const url = settings.url + rotas.fornecedorProduto;

    const retorno = rest.get(url /*+ useCentralLojas.centralLoja().filial_id*/);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setFabricantes(lista);
      }
    })
  }

  const handleFilial = (evt) => {
    setFilialId(evt.id);
  }

  const handleFiltroMarkup = (obj, origem) => {
    let ft = { ...filtroMarkup };

    if (origem == 'menorMarkup') {
      ft.menorMarkup = obj.target.value;
    }

    if (origem == 'maiorMarkup') {
      ft.maiorMarkup = obj.target.value;
    }
    setFiltroMarkup(ft);
  }

  const handleOpcoes = (obj, origem) => {
    let opt = { ...opcoes };

    if (origem == 'prodSaldo') {
      opt.prod_saldo = obj.target.checked ? 'S' : 'N';
    }

    if (origem == 'precoZero') {
      opt.preco_zero = obj.target.checked ? 'S' : 'N';
    }

    if (origem == 'precoNaoZero') {
      opt.preco_nao_zero = obj.target.checked ? 'S' : 'N';
    }

    setOpcoes(opt);
  }

  const handleFiltros = (obj, origem) => {

    setFiltroMarkup(initialFiltroMarkup);

    let flt = [];

    if ((origem === 'categoria') || (origem === 'subcategoria')) {
      flt = filtro;
    }

    if (origem === 'produto') {
      setTags([...tags, obj.title]);
      flt.push({ produto_id: 0, chave: obj.title })
    }

    if (origem === 'categoria') {
      setTags([...tags, obj.title]);

      let idx = flt.findIndex(value => value.categoria_id != undefined);

      if (idx >= 0) {
        flt[idx] = { ...flt[idx], categoria_id: obj.id, chave: obj.title };
      } else {
        flt.push({ categoria_id: obj.id, chave: obj.title })
      }
    }

    if (origem === 'subcategoria') {
      setTags([...tags, obj.title]);

      let idx = flt.findIndex(value => value.subcategoria_id != undefined);

      if (idx >= 0) {
        flt[idx] = { ...flt[idx], subcategoria_id: obj.id, chave: obj.title };
      } else {
        flt.push({ subcategoria_id: obj.id, chave: obj.title })
      }
    }

    if (origem === 'grupo_compra') {
      setTags([...tags, obj.title]);
      flt.push({ grupo_compra_id: obj.id, chave: obj.title })
    }

    if (origem === 'fabricante') {
      setTags([...tags, obj.title]);
      flt.push({ fornecedor_id: obj.id, chave: obj.title })
    }

    if (origem == 'nota_fiscal') {
      flt.push({ nota_fiscal: obj.target.value })
    }
    setFiltro(flt);
  }

  const handleInput = (evt) => {
    setProdutoPesquisa(evt.target.value);
    handleFiltros({ title: evt.target.value }, 'produto')
  }

  const keyDown = (evt) => {
    handleFiltros({ title: evt.target.value }, 'produto')
    if ((evt.keyCode === 13) && (evt.target.value !== "")) {
      filtrarProdutos();
      // let tgs = tags;
      // tgs.push(evt.target.value);
      // setTags(tgs);
      // setRefresh(refresh+1);
    }
  }

  const listarProdutosHistorico = (cab_precificacao_id) => {
    setLoadingComponent(true);
    setReadOnlyTable(true);
    setData([]);

    const url = settings.url + rotas.precificacaoHistoricoProdutos;

    let parametros = "cab_precificacao_id=" + cab_precificacao_id;

    const retorno = rest.get(url + `?${parametros}`);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setData(ret.lista);
      }
      setLoadingComponent(false);
      // setIsOpenCollapse(false);
    })
  }

  const filtrarProdutos = (notaEspecifica) => {
    
    if ((filtro.length == 0) && (filtroMarkup.menorMarkup == '') && (filtroMarkup.maiorMarkup == '')) {
      Swal.fire('Atenção', 'Selecione uma opção de filtro!', 'warning');
      return;
    }

    setData([]);
    setDataSite([]);
    setListaNotasDuplicadas([]);
    setPagina(0);

    if (filialID > 0) {
      setLoadingComponent(true);
      setReadOnlyTable(false);
      const url = settings.url + rotas.produtosPrecificador;

      let flt = [];

      flt = filtro;

      let parametros = { filial_id: filialID, filtros: flt, opcoes: opcoes, pagina: pagina, nota_especifica: notaEspecifica };

      const retorno = rest.post(url, parametros);

      retorno.then(ret => {
        setLoadingComponent(false);
        if (ret.success === 'S') {

          if (ret.notas != undefined) {

            setListaNotasDuplicadas(ret.notas);

          } else {
            ret.retorno.map(lista => {
              lista.checked = false;
              lista.markup = calculaMarkup({
                valor_ult_compra: lista.valor_ult_compra,
                prod_prvenda: lista.prod_prvenda,
                prod_prpromocao: lista.prod_prpromocao,
                prod_prcrediario: lista.prod_prcrediario
              })

              lista.margem_lucro = calculaMargemLucro({
                valor_ult_compra: lista.valor_ult_compra,
                prod_prvenda: lista.prod_prvenda,
                prod_prpromocao: lista.prod_prpromocao,
                prod_prcrediario: lista.prod_prcrediario
              })
            })

            if (filtroMarkup.menorMarkup != 0) {
              let dt = [];
              ret.retorno.map(linha => {

                if ((parseFloat(linha.markup) >= parseFloat(filtroMarkup.menorMarkup)) && (parseFloat(linha.markup) <= parseFloat(filtroMarkup.maiorMarkup))) {
                  dt.push(linha);
                }
              })
              setDataSite(dt);
              setPagina(1);
            } else {
              setDataSite(ret.retorno);
              setPagina(1);
            }
          }


        } else {
          Swal.fire('Erro', ret.msg, 'error');
        }
      })
    } else {
      Swal.fire('Loja', 'Por favor selecione a loja!');
    }
  }

  const precoZero = () => {
    let precoZero = false;
    data.map(dt => {
      if (dt.checked) {
        if (dt.prod_prvenda == 0) {
          precoZero = true;
        }
      }
    })
    return (precoZero);
  }

  const selectTable = (row, isSelect, rowIndex, e, selectAll) => {
    let newDataSite;

    if (selectAll) {
      newDataSite = dataSite.map(dat => ({ ...dat, checked: isSelect }));
    } else {
      newDataSite = dataSite.map(dat =>
        dat.produto_id === row.produto_id ? { ...dat, checked: isSelect } : dat
      );
    }

    setDataSite(newDataSite);
    const inicio = pagina > 0 ? (pagina - 1) * quantPagina : 0;
    setData(newDataSite.slice(inicio, inicio + quantPagina));
  }

  /* const calculaMarkup = (precos) =>{
     let diferenca=0;
     let valorComparar=0;
     if(precos.valor_ult_compra>0){
   
     //COLOCA O PRECO A COMPARAR IGUAL A UM DOS PRECOS PRA NAO FICAR ZERADO
     if((valorComparar===0)&&(precos.prod_prvenda>0)){
     
       valorComparar=precos.prod_prvenda;
     }
     else
     if((valorComparar===0)&&(precos.prod_prpromocao>0)){
     
       valorComparar=precos.prod_prpromocao;
     }
     else
     if((valorComparar===0)&&(precos.prod_prcrediario>0)){
     
       valorComparar=precos.prod_prcrediario;
     }
 
     //COMPARA OS PRECOS PARA O VALOR A COMPARAR FICAR COM O MENOR DELES
     if((valorComparar > precos.prod_prvenda)&&(precos.prod_prvenda > 0)){
     
       valorComparar=preco_venda;
     }
 
     if((valorComparar > precos.prod_prpromocao )&&(precos.prod_prpromocao > 0)) {
     
       valorComparar=precos.prod_prpromocao;
     }
 
     if((valorComparar > precos.prod_prcrediario)&&(precos.prod_prcrediario>0)){
     
       valorComparar=precos.prod_prcrediario;
     }
 
     //CALCULA O MARKUP COM O MENOR DOS PRECOS
     diferenca=Math.round(valorComparar-preco_compra).toFixed(2);
     total=((diferenca/preco_compra)*100);
     total=Math.round(total).toFixed(2);
   }
 
   return(total);
   }*/

  const calculadora = (preco_base, fator, tipo_fator, inc_dec) => {
    /** FUNCAO QUE CALCULA O NOVO PRECO A SER ATUALIZADO
     * PRECO_BASE : PRECO DE ONDE PARTIRA O VALOR
     * FATOR      : FATOR A SER ACRESCENTADO
     * TIPO_FATOR : P =  PORCENTAGEM ; V = VALOR EM REAL
     * INC_DEC    : I = INCREMENTAL; D = DECREMENTAL; F = VALOR FIXO
    */

    //SE FOR VALOR FIXO
    if (inc_dec === 'F') {

      return (fator);
    }
    else {  //SE FOR INCREMENTAL OU DECREMENTAL

      //CALCULA A PORCENTAGEM
      if (tipo_fator === 'P') {
        //INCREMENTA O PRECO
        if (inc_dec === 'I') {
          return (Number(preco_base + ((preco_base * fator) / 100)).toFixed(2));
        }

        //DECREMENTA O PRECO
        if (inc_dec === 'D') {

          return (Number(preco_base - ((preco_base * fator) / 100)).toFixed(2));
        }
      }

      if (tipo_fator === 'V') {

        //INCREMENTA O VALOR
        if (inc_dec === 'I') {

          return (Number(preco_base + fator).toFixed(2));
        }

        //DECREMENTA O VALOR
        if (inc_dec === 'D') {
          return (Number(preco_base - fator).toFixed(2));
        }
      }
    }
  }

  const filtroParametros = (obj, campo) => {
    let params = { ...parametrosPrecificador };

    if (campo === 'tipo_alteracao') {
      params.tipoAlteracao = obj.title;

      if (obj.title == 'Valor Fixo') {
        params.tipoValor = '(R$) Valor';
      }
    }

    if (campo === 'tipo_preco') {
      params.tipoPreco = obj.title;
    }

    if (campo === 'tipo_valor') {
      params.tipoValor = obj.title;
    }

    if (campo === 'preco_base') {
      params.precoBase = obj.title;
    }

    if (campo === 'valor_reajustar') {
      params.valorReajustar = obj.target.value;
    }

    setParametrosPrecificador(params);
    setRefresh(refresh + 1)
  }

  const validaParametros = () => {

    if (parametrosPrecificador.tipoAlteracao === '') {
      Swal.fire('Erro',
        'Selecione o tipo de alteração a ser feito',
        'error'
      );
      return (false);
    }

    if (parametrosPrecificador.tipoPreco === '') {
      Swal.fire('Erro',
        'Selecione o tipo de preço a ser alterado',
        'error'
      );
      return (false);
    }

    if (parametrosPrecificador.tipoValor === '') {
      Swal.fire('Erro',
        'Selecione o tipo de valor a ser usado',
        'error'
      );
      return (false);
    }

    if ((parametrosPrecificador.precoBase === '') && (parametrosPrecificador.tipoAlteracao != "Valor Fixo")) {
      Swal.fire('Erro',
        'Selecione o preço de origem a ser usado',
        'error'
      );
      return (false);
    }

    if (parametrosPrecificador.valorReajustar <= 0) {
      Swal.fire('Erro',
        'Selecione o valor a ser ajustado',
        'error'
      );
      return (false);
    }

    let itensMarcados = 0;
    data.map(lista => {
      if (lista.checked) {
        itensMarcados++;
      }
    })

    if (itensMarcados == 0) {
      Swal.fire('Atenção',
        'Nenhum produto selecionado',
        'warning'
      );
    }

    return (true);
  }

  const visualizaPrecificacao = async () => {
    if (!validaParametros()) return null;

    let fator = parametrosPrecificador.valorReajustar;
    fator = fator.replace(',', '.');
    if (fator.includes('.')) {
      if (countSubstr(fator, '.') > 1) {
        fator = (fator.replace(/[^0-9]/g, '') / 100);
      } else {
        fator = fator.replace(/[^0-9.]/g, '');
      }
    } else {
      fator = fator.replace(/[^0-9]/g, '');
    }

    let tipoFator = '';
    if (parametrosPrecificador.tipoValor === '(%) Porcentagem') tipoFator = 'P';
    if (parametrosPrecificador.tipoValor === '(R$) Valor') tipoFator = 'V';

    let incDec = '';
    if (parametrosPrecificador.tipoAlteracao === 'Incremental') incDec = 'I';
    if (parametrosPrecificador.tipoAlteracao === 'Decremental') incDec = 'D';
    if (parametrosPrecificador.tipoAlteracao === 'Valor Fixo') incDec = 'F';

    const dt = dataSite.map(dat => {
      if (!dat.checked) return { ...dat };

      let precoBase = 0;
      if (parametrosPrecificador.precoBase === 'Sobre o Preço de Compra') precoBase = dat.valor_ult_compra;
      if (parametrosPrecificador.precoBase === 'Sobre o Preço de Venda') precoBase = dat.prod_prvenda;
      if (parametrosPrecificador.precoBase === 'Sobre o Preço de Promoção') precoBase = dat.prod_prpromocao;
      if (parametrosPrecificador.precoBase === 'Sobre o Preço de Crediário') precoBase = dat.prod_prcrediario;
      if (parametrosPrecificador.precoBase === 'Sobre o Preço Fidelidade') precoBase = dat.prod_prfidelidade;

      const novoPreco = calculadora(parseFloat(precoBase), parseFloat(fator), tipoFator, incDec);

      const updated = { ...dat };
      if (parametrosPrecificador.tipoPreco === 'Preço de Venda') updated.prod_prvenda = novoPreco;
      if (parametrosPrecificador.tipoPreco === 'Preço de Promoção') updated.prod_prpromocao = novoPreco;
      if (parametrosPrecificador.tipoPreco === 'Preço de Crediário') updated.prod_prcrediario = novoPreco;
      if (parametrosPrecificador.tipoPreco === 'Preço Fidelidade') updated.prod_prfidelidade = novoPreco;

      updated.markup = calculaMarkup({
        valor_ult_compra: updated.valor_ult_compra,
        prod_prvenda: updated.prod_prvenda,
        prod_prpromocao: updated.prod_prpromocao,
        prod_prcrediario: updated.prod_prcrediario
      });
      updated.margem_lucro = calculaMargemLucro({
        valor_ult_compra: updated.valor_ult_compra,
        prod_prvenda: updated.prod_prvenda,
        prod_prpromocao: updated.prod_prpromocao,
        prod_prcrediario: updated.prod_prcrediario
      });

      return updated;
    });

    return dt;
  }

  const menuFiltroProdutos = (e) => {

    if (tipoFiltroPrecificacao != e.title) {
      if ((tipoFiltroPrecificacao == 'Categoria') && (e.title != 'Subcategoria')) {
        setFiltro([]);
      }

      if ((tipoFiltroPrecificacao == 'Subcategoria') && (e.title != 'Categoria')) {
        setFiltro([]);
      }

      if ((tipoFiltroPrecificacao == 'Subcategoria') && (e.title == 'Categoria')) {
        let flt = [];
        filtro.map((f) => {
          if (f.subcategoria_id == undefined) {
            flt.push(f);
          }
        })

        setFiltro(flt);
      }
    }
    setTipoFiltroPrecificacao(e.title);
    setFiltro([]);
  }

  const carregaLoading = (status) => {
    setLoadingComponent(status);
    setRefresh(refresh + 1)
  }

  const checkAll = (valor) => {
    const newDataSite = dataSite.map(dt => ({ ...dt, checked: valor }));
    setDataSite(newDataSite);
    const inicio = pagina > 0 ? (pagina - 1) * quantPagina : 0;
    setData(newDataSite.slice(inicio, inicio + quantPagina));
  }

  const preparaPrecificacao = () => {
    if (!data || data.length === 0) {
      Swal.fire('Atenção', 'Nenhum Produto Listado!', 'warning');
      return;
    }

    const visualiza = visualizaPrecificacao();
    if (!visualiza) return;

    visualiza.then(ret => {
      if (!ret) return;
      setDataSite(ret);
      const inicio = pagina > 0 ? (pagina - 1) * quantPagina : 0;
      setData(ret.slice(inicio, inicio + quantPagina));
    });
  }

  const excluirItem = (row) => {
    let dt = [];

    data.map(dat => {
      if (dat.produto_id !== row.produto_id) {
        dt.push(dat);
      }
    })
    setData(dt);
    setRefresh(refresh + 1);
  }

  const onChangeDate = (evt, campo) => {

    if (evt.length != undefined) {
      if (evt.length === 2) {
        setFiltroHistorico({
          ...filtroHistorico,
          [campo]: evt + '/'
        })
      } else if (evt.length === 5) {
        setFiltroHistorico({
          ...filtroHistorico,
          [campo]: evt + '/'
        })
      } else if (evt.length >= 6 && evt.length <= 10) {
        setFiltroHistorico({
          ...filtroHistorico,
          [campo]: evt
        })
      } else if (evt.length > 10) {
        setFiltroHistorico({
          ...filtroHistorico,
          [campo]: evt[campo]
        })
      }
    } else {
      setFiltroHistorico({
        ...filtroHistorico,
        [campo]: evt.format('DD/MM/YYYY')
      })
    }
  }

  const listarHistorico = () => {
    setLoadingHistorico(true);
    setData([]);
    setDataSite([])

    const url = settings.url + rotas.precificacaoHistorico;

    let parametros = '';

    if (filtroHistorico.dataInicial !== "") {
      parametros = parametros + 'dataI=' + moment(filtroHistorico.dataInicial, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    if (filtroHistorico.dataFinal !== "") {
      parametros = parametros + '&dataF=' + moment(filtroHistorico.dataFinal, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    const retorno = rest.get(url + '?' + parametros);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setHistoricoPrecificacao(ret.lista);
        setIsOpenCollapse(true);
      }
      setLoadingHistorico(false)
    })
  }

  const precificar = () => {
    
    if (filialID > 0) {
      if (precoZero() == true) {
        Swal.fire('Atenção', 'Existem Produtos com Preço de Venda Zero, Verifique!', 'error');
        return;
      }

      if ((dataSite) && (dataSite.length > 0)) {
        setLoadingComponent(true);

        const url = settings.url + rotas.precificar;

        let parametros = { filial_id: filialID, produtos: dataSite, filtros: filtro };

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success === 'S') {
            Swal.fire('Sucesso', 'Precificação efetuada com sucesso!', 'success');
          } else {
            Swal.fire('Erro', ret.msg, 'error');
          }
          setLoadingComponent(false);
        })
      } else {
        Swal.fire('Atenção', 'Nenhum Produto Listado!', 'warning');
      }
    } else {
      Swal.fire('Loja', 'Por favor selecione a loja!', 'warning');
    }
  }

  const handleColunas = (e) => {
    const cl = colunas.map(col =>
      col.datafield === e.target.name ? { ...col, visible: e.target.checked } : col
    );
    setColunas(cl);
  }

  const gravaColunas = () => {

    Swal.fire({
      title: "Confirmação",
      text: "Confirma a gravação das alterações?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {

        let url = rotas.precificacaoColunas;

        let parametros = {
          colunas: colunas
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            Swal.fire({
              title: "Sucesso",
              text: "Registro gravado com sucesso!",
              icon: "success"
            });
            setModalColunas(false);
          } else {
            Swal.fire(
              'Erro',
              'Erro gravando os dados, por favor verifique!',
              'error'
            )
          }
        })

      }
    });
  }

  const gravaPosicaoColunas = (newCol) => {

    let url = rotas.precificacaoColunas;

    newCol.map((col, idx) => {
      col.posicao_id = idx + 1;
    })

    let parametros = {
      colunas: newCol
    }

    const retorno = rest.put(url, parametros);

    retorno.then(ret => {
      if(newCol[0].coluna_usuario_id == '0'){
        listarColunas();
      }
      if (ret.success != 'S') {
        Swal.fire(
          'Erro',
          'Erro gravando a nova posição da coluna!',
          'error'
        )
      }
    })
  }

  const resetParams = () => {
    // setFiltro([]);
    // setTags([]);  
    setProdutoPesquisa('');
    // setFiltroMarkup(initialFiltroMarkup); 
    // setOpcoes(initialOpcoes);
    // setParametrosPrecificador(inititalParams);
    // setTipoFiltroPrecificacao('');
    setData([]);
    setDataSite([]);
    setPagina(0);
    // setListaNotasDuplicadas([]);
  }

  const resetColunas = () => {
    let url = rotas.precificacaoColunas;

    const retorno = rest.del(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        Swal.fire(
          'Sucesso',
          'Registro Gravado com Sucesso',
          'success'
        ).then(
          setModalColunas(false)
        )
      } else {
        Swal.fire(
          'Erro',
          'Erro atualizando os dados!',
          'error'
        )
      }
    })
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <>
        <div className="content">
          <Container>
            <Modal
              isOpen={listaNotasDuplicadas.length > 0 ? true : false}
              size={'lg'}
            // toggle={()=>{console.log('close')})} 
            // {...args}
            >
              <ModalHeader
              // toggle={toggle}
              >Por Favor Selecione uma Nota Fiscal</ModalHeader>
              <ModalBody>
                <Table hover>
                  <thead>
                    <tr>
                      <th>
                        #
                      </th>
                      <th>
                        Fantasia
                      </th>
                      <th>
                        Nota Fiscal
                      </th>
                      <th>
                        Data Recebimento
                      </th>
                      <th>
                        Valor Total
                      </th>
                      <th>
                        Fornecedor
                      </th>
                      <th>

                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaNotasDuplicadas.map((nota, idx) =>
                      <tr>
                        <th scope="row">
                          {idx + 1}
                        </th>
                        <td>
                          {nota.fantasia}
                        </td>
                        <td>
                          {nota.nota_fiscal}
                        </td>
                        <td>
                          {nota.data_recebimento}
                        </td>
                        <td>
                          {nota.valor_total}
                        </td>
                        <td>
                          {nota.fornecedor}
                        </td>
                        <td>
                          <Button
                            color={'success'}
                            onClick={() => {
                              filtrarProdutos({ cab_nota_id: nota.cab_nota_id, filial_id: nota.filial_id });
                            }}
                          >
                            Selecionar
                          </Button>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              {/* <ModalFooter>
                <Button
                  color="primary"
                // onClick={toggle}
                >
                  Do Something
                </Button>{' '}
                <Button
                  color="secondary"
                // onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalFooter> */}
            </Modal>

            <Modal isOpen={modalColunas} size='lg'
            // toggle={toggleModalColunas}
            >
              <ModalHeader
              // toggle={toggle}
              >Colunas Visíveis</ModalHeader>
              <ModalBody>
                <Row>
                  {colunas.map((col, idx) =>
                    col.text &&
                    <Col md='4'
                      key={`col-${idx}`}
                    >
                      <FormGroup check inline className="mt-2">
                        <Label check>
                          <Input
                            type="checkbox"
                            name={col.datafield}
                            // id=""
                            onClick={handleColunas}
                            defaultChecked={col.visible}
                          />
                          <span className="form-check-sign" />{col.text}
                        </Label>
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </ModalBody>
              <ModalFooter>
                <Col md='6'
                  className="pl-4"
                >
                  <Button color="info"
                    onClick={resetColunas}
                  >
                    Restaurar Posição das Colunas
                  </Button>{' '}
                </Col>

                <Col md='6'
                  className="d-flex justify-content-end"
                >
                  <Button color="success"
                    onClick={gravaColunas}
                  >
                    Gravar
                  </Button>{' '}
                  <Button
                    color="secondary"
                    onClick={() => { setModalColunas(false) }}
                  >
                    Cancelar
                  </Button>
                </Col>
              </ModalFooter>
            </Modal>
            <Row>
              <Col md="12" className="p-0">
                <Card>
                  <CardHeader>
                    <Row>
                      <Col md='11'>
                        <CardTitle>PRECIFICAÇÕES</CardTitle>
                      </Col>
                      <Col
                        md='1'
                        className='align-content-center text-right '
                      >
                        {/* <Button 
                          size="sm"
                          style={{width:'32px', heigth:'32px'}}
                        > */}
                        <i className="nc-icon nc-settings border p-2"
                          data-toggle="tooltip" data-placement="top" title="Editar Colunas"
                          style={{ fontSize: '18px', color: '#808080', borderColor: '#808080', cursor: 'pointer' }}
                          onClick={() => { setModalColunas(true) }}
                        />
                        {/* </Button> */}
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>


                    <div>
                      <div className="border p-3">
                        {/* ABAS */}
                        <Nav pills className="nav-pills-default justify-content-center mb-3">

                          <NavItem>
                            <NavLink
                              active={activeTab === '1' ? true : false}
                              onClick={() => { toggleTab('1'); }}
                            >
                              Filtros
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              active={activeTab === '2' ? true : false}
                              onClick={() => { toggleTab('2'); }}
                            >
                              Classificação
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              active={activeTab === '3' ? true : false}
                              onClick={() => { toggleTab('3'); }}
                            >
                              Histórico
                            </NavLink>
                          </NavItem>
                        </Nav>

                        {/* ANALISAR */}
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                            <Form>

                            </Form>
                          </TabPane>
                        </TabContent>

                        {/* FILTROS */}
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                            <Row>
                              <Col>
                                <FormGroup>
                                  <ReactSelect
                                    name="lojas"
                                    placeholder="Selecione a Loja"
                                    options={lojas}
                                    //defaultValue= {form.fornecedor}
                                    onChange={handleFilial}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                              <Col>
                                <FormGroup className="mb-0">
                                  <ReactSelect
                                    name="filtro-precificacao"
                                    placeholder="Selecione o filtro"
                                    options={listaFiltros}
                                    //defaultValue= {form.fornecedor}
                                    onChange={menuFiltroProdutos}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                            </Row>

                            <Row>
                              {tipoFiltroPrecificacao == 'Nota Fiscal' &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <Input
                                      placeholder='Número da Nota Fiscal'
                                      onChange={(evt) => { handleFiltros(evt, 'nota_fiscal') }}
                                      onKeyDown={(evt) => {
                                        if ((evt.keyCode === 13) && (evt.target.value !== "")) {
                                          filtrarProdutos();
                                        }
                                      }
                                      }
                                    ></Input>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Produto' &&
                                <Col /*className=" border-right"*/>
                                  <FormGroup>
                                    <Input
                                      name="produto"
                                      id="produto"
                                      placeholder="Nome, código ou cód. de barras..."
                                      //value={form.cli_bairro}
                                      onChange={handleInput}
                                      onKeyDown={keyDown}
                                    />
                                  </FormGroup>
                                </Col>
                              }

                              {(tipoFiltroPrecificacao == 'Categoria' || tipoFiltroPrecificacao == 'Subcategoria') &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="categoria"
                                      placeholder="Selecione a Categoria"
                                      options={categorias}
                                      //defaultValue= {form.fornecedor}
                                      onChange={(obj) => { handleFiltros(obj, 'categoria') }}
                                    ></ReactSelect>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Subcategoria' &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="subcategoria"
                                      placeholder="Selecione a Subcategoria"
                                      options={subcategorias}
                                      //defaultValue= {form.fornecedor}
                                      onChange={(obj) => { handleFiltros(obj, 'subcategoria') }}
                                    ></ReactSelect>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Grupo de Compras' &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="grupo-compra"
                                      placeholder="Selecione o Grupo de Compras"
                                      options={grupoCompras}
                                      //defaultValue= {form.fornecedor}
                                      onChange={(obj) => { handleFiltros(obj, 'grupo_compra') }}
                                    ></ReactSelect>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Fabricante' &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="fabricante"
                                      placeholder="Selecione o Fabricante"
                                      options={fabricantes}
                                      //defaultValue= {form.fornecedor}
                                      onChange={(obj) => { handleFiltros(obj, 'fabricante') }}
                                    ></ReactSelect>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Perfil de Preço' &&
                                <Col>
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="perfilPreco"
                                      placeholder="Selecione o Perfil de Preço"
                                      options={listaPerfilPreco}
                                      //defaultValue= {form.fornecedor}
                                      onChange={(obj) => { handleFiltros(obj, 'perfilPreco') }}
                                    ></ReactSelect>
                                  </FormGroup>
                                </Col>
                              }

                              {tipoFiltroPrecificacao == 'Faixa de Markup' &&
                                <>
                                  <Col>
                                    <FormGroup className="mb-0">
                                      <Input
                                        placeholder='Menor Markup'
                                        //value = {parametrosPrecificador.valorReajustar}
                                        onChange={(evt) => { handleFiltroMarkup(evt, 'menorMarkup') }}
                                      ></Input>
                                    </FormGroup>
                                  </Col>

                                  <Col>
                                    <FormGroup className="mb-0">
                                      <Input
                                        placeholder='Maior Markup'
                                        //value = {parametrosPrecificador.valorReajustar}
                                        onChange={(evt) => { handleFiltroMarkup(evt, 'maiorMarkup') }}
                                      ></Input>
                                    </FormGroup>
                                  </Col>
                                </>
                              }

                              {tipoFiltroPrecificacao !== '' &&
                                <Col md="2" className="">
                                  <Button
                                    className="w-100 m-0"
                                    color="success"
                                    onClick={() => { filtrarProdutos() }}
                                  >Filtrar
                                  </Button>
                                </Col>
                              }

                            </Row>

                            <Row className="card-2 pb-1 pt-3">
                              <Col className="d-flex flex-column">
                                <span className="tag-card">Opções</span>

                                <FormGroup check inline className="mt-2">
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      id="prod_ativo"
                                      onClick={(obj) => { handleOpcoes(obj, 'prodSaldo') }}
                                      defaultChecked={opcoes.prod_saldo === 'S' ? true : false}
                                    />
                                    <span className="form-check-sign" />Somente produtos com saldo
                                  </Label>
                                </FormGroup>{" "}
                              </Col>

                              <Col className="d-flex flex-column">
                                <FormGroup check inline className="mt-2">
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      id="prod_ativo"
                                      onClick={(obj) => { handleOpcoes(obj, 'precoNaoZero') }}
                                      defaultChecked={opcoes.preco_nao_zero === 'S' ? true : false}
                                    />
                                    <span className="form-check-sign" />{"Somente produtos com preço de venda maior que R$ 0,00"}
                                  </Label>
                                </FormGroup>{" "}
                              </Col>

                              <Col className="d-flex flex-column">
                                <FormGroup check inline className="mt-2">
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      id="prod_ativo"
                                      onClick={(obj) => { handleOpcoes(obj, 'precoZero') }}
                                      defaultChecked={opcoes.preco_zero === 'S' ? true : false}
                                    />
                                    <span className="form-check-sign" />{"Somente produtos com preço de venda igual a R$ 0,00"}
                                  </Label>
                                </FormGroup>{" "}
                              </Col>

                            </Row>

                            {/* <Row>
                                    <Col>
                                      <div className="card-2">
                                        <Col className="p-0">
                                          <span className="tag-card">Lista</span>
                                          <TagsInput
                                            //placeholder={"Lista"}
                                            inputProps={{ placeholder: "" }}
                                            value={tags}
                                            onChange={handleAddition}
                                          />
                                        </Col>
                                      </div>
                                    </Col>
                                  </Row> */}
                            {/* </Form> */}
                          </TabPane>
                        </TabContent>

                        {/* CLASSIFICAÇÃO- */}
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="2">

                            <Row>
                              <Col>
                                <FormGroup >
                                  <ReactSelect
                                    name="tipo-alteracao"
                                    placeholder="Selecione o tipo de alteração"
                                    options={listaAlteracoes}
                                    //defaultValue= {form.fornecedor}
                                    onChange={(obj) => { filtroParametros(obj, 'tipo_alteracao') }}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                              <Col>
                                <FormGroup >
                                  <ReactSelect
                                    name="tipo-preco"
                                    placeholder="Selecione o tipo de preço"
                                    options={listaPrecos}
                                    //defaultValue= {form.fornecedor}
                                    onChange={(obj) => { filtroParametros(obj, 'tipo_preco') }}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                            </Row>
                            <Row className="justify-content-md-center">

                              <Col>
                                <FormGroup >
                                  <ReactSelect
                                    name="preco-base"
                                    placeholder="Selecione o valor de origem"
                                    options={listaPrecoBase}
                                    //defaultValue= {form.fornecedor}
                                    onChange={(obj) => { filtroParametros(obj, 'preco_base') }}
                                    isDisabled={disableValor}
                                    value={defaultValorOrigem}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                              <Col>
                                <FormGroup className="mb-0">
                                  <ReactSelect
                                    name="tipo-valor"
                                    placeholder="Selecione o tipo de valor"
                                    options={listaTipoValor}
                                    value={defaultTipoValor}
                                    onChange={(obj) => { filtroParametros(obj, 'tipo_valor') }}
                                    // isDisabled={parametrosPrecificador.tipoAlteracao === 'Valor Fixo' ? true : false}
                                    isDisabled={disableValor}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>


                              <Col md="2">
                                <FormGroup className="mb-0">
                                  <Input
                                    placeholder='Digite o valor'
                                    //value = {parametrosPrecificador.valorReajustar}
                                    onChange={(evt) => { filtroParametros(evt, 'valor_reajustar') }}
                                  ></Input>
                                </FormGroup>
                              </Col>
                            </Row>

                            <Col className="text-center pt-2 pb-1">
                              <Button
                                className="mb-0 mt-0"
                                color="info"
                                onClick={preparaPrecificacao}
                                size="sm"
                                disabled={readOnlyTable}
                              >Visualizar
                              </Button>

                              <Button
                                className="mb-0 mt-0"
                                color="success"
                                onClick={precificar}
                                size="sm"
                                disabled={readOnlyTable}
                              >Salvar
                              </Button>
                            </Col>

                          </TabPane>
                        </TabContent>

                        {/* CLASSIFICAÇÃO- */}
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="3">

                            <Row>
                              <Col md='5'>
                                <FormGroup>
                                  <DateTime
                                    id="dataInicial"
                                    name="dataInicial"
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    dateFormat="YYYY-MM-DD"
                                    value={filtroHistorico.dataInicial}
                                    onChange={(e) => { onChangeDate(e, 'dataInicial') }}
                                    inputProps={{
                                      //   className: disabeldFiltros.dataI === true ? "form-control disabledCampo" : "form-control",
                                      placeholder: "Data Inicial",
                                      //   disabled: disabeldFiltros.dataI
                                    }}
                                  />
                                </FormGroup>
                              </Col>

                              <Col md='5'>
                                <FormGroup>
                                  <DateTime
                                    id="dataFinal"
                                    name="dataFinal"
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    dateFormat="YYYY-MM-DD"
                                    value={filtroHistorico.dataFinal}
                                    onChange={(evt) => { onChangeDate(evt, 'dataFinal') }}
                                    inputProps={{
                                      //   className: disabeldFiltros.dataI === true ? "form-control disabledCampo" : "form-control",
                                      placeholder: "Data Final",
                                      //   disabled: disabeldFiltros.dataI
                                    }}
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="2" className="text-center pt-2 pb-1">
                                <Button
                                  className="mb-0 mt-0"
                                  color="success"
                                  onClick={listarHistorico}
                                  size="sm"
                                >Pesquisar
                                </Button>
                              </Col>

                            </Row>

                            {loadingHistorico && <Loading tipo='componente'></Loading>}

                            <Row style={{
                              border: 'solid',
                              borderWidth: '0.3px',
                              borderColor: '#dee2e6',
                              marginLeft: '1px',
                              marginRight: '1px'
                            }}
                            >
                              <Col md='12'>
                                <div
                                  aria-multiselectable={true}
                                  className="card-collapse"
                                  id="accordion"
                                  role="tablist"
                                >
                                  {/* <div> */}
                                  {/* <div className='d-flex justify-content-between'> */}
                                  {/* <h6 className='text-center d-block mx-auto pt-3'>Resultado da Pesquisa</h6> */}
                                  <a
                                    style={{ color: 'black', display: 'block', textAlign: 'end' }}
                                    className='pt-2'
                                    aria-expanded={isOpenCollapse}
                                    href="#"
                                    data-parent="#accordion"
                                    data-toggle="collapse"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setIsOpenCollapse(!isOpenCollapse)
                                    }}
                                  >
                                    <i
                                      className={isOpenCollapse ? "nc-icon nc-minimal-up border rounded-circle p-1" : "nc-icon nc-minimal-down border rounded-circle p-1"}
                                    />
                                  </a>
                                  {/* </div> */}
                                  <Col md='12'>
                                    <Collapse
                                      role="tabpanel"
                                      isOpen={isOpenCollapse}
                                    // style={{maxHeight:'300px',overflowY:'scroll'}}
                                    >
                                      <div>
                                        <Table striped>
                                          <thead>
                                            <tr>
                                              <th>
                                                Código
                                              </th>
                                              <th>
                                                Loja
                                              </th>
                                              <th>
                                                Data Precificação
                                              </th>
                                              <th>
                                                Filtro
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {historicoPrecificacao.map(lista =>
                                              <tr>
                                                <th scope="row">
                                                  {lista.cab_precificacao_id}
                                                </th>
                                                <td>
                                                  {lista.fantasia}
                                                </td>
                                                <td>
                                                  {moment(lista.data_precificacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                                                </td>
                                                <td>
                                                  {lista.filtro}
                                                </td>
                                                <td>
                                                  <Button
                                                    onClick={() => { listarProdutosHistorico(lista.cab_precificacao_id) }}
                                                    color='info'
                                                    className='btn-sm'
                                                  >Detalhes</Button>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </Collapse>
                                  </Col>
                                </div>
                              </Col>
                            </Row>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>

                    {loadingComponent && <Loading tipo='componente'></Loading>}

                    {!loadingComponent &&
                      <DataTable
                        columns={colunas}
                        data={data}
                        readOnly={readOnlyTable}
                        checkAll={checkAll}
                        onlyChecked={onlyChecked}
                        recalculaMargemMkp={recalculaMargemMkp}
                        onFieldChange={onFieldChange}
                        setColumn={setColunas}
                        gravaPosicaoColunas={gravaPosicaoColunas}
                      ></DataTable>
                    }

                  </CardBody>
                  <div className='d-flex justify-content-center'>
                    <Pagination
                      aria-label="Page navigation example"
                      size="sm"
                    >
                      <PaginationItem
                        disabled={pagina == 1}
                      >
                        <PaginationLink
                          first
                          href="#"
                          onClick={() => {
                            setPagina(1);
                          }}
                        />
                      </PaginationItem>
                      <PaginationItem
                        disabled={pagina == 1}
                      >
                        <PaginationLink
                          href="#"
                          previous
                          onClick={() => {
                            setPagina(pagina - 1);
                          }}
                        />
                      </PaginationItem>
                      {controlePaginacao.paginasExibir.map((pg, idx) =>
                        <PaginationItem
                          key={idx}
                          active={pagina == pg}
                        >
                          <PaginationLink
                            href="#"
                            onClick={() => {
                              setPagina(pg);
                            }}
                          >
                            {pg}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      <PaginationItem
                        disabled={pagina == controlePaginacao.totalPaginas}
                      >
                        <PaginationLink
                          href="#"
                          next
                          onClick={() => {
                            setPagina(pagina + 1);
                          }}
                        />
                      </PaginationItem>
                      <PaginationItem
                        disabled={pagina == controlePaginacao.totalPaginas}
                      >
                        <PaginationLink
                          href="#"
                          last
                          onClick={() => {
                            setPagina(controlePaginacao.totalPaginas);
                          }}
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container >
        </div >
      </>
    )
  }
}

export default Precificacoes;